"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.input = exports.root = void 0;
var react_1 = require("@emotion/react");
var tokens_1 = require("@prezzee/tokens");
var root = function (_a) {
    var error = _a.error, focused = _a.focused, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  border-radius: 4px;\n\n  ", "\n  ", "\n\n  ", "\n"])), startAdornment && 'padding-left: 14px;', endAdornment && 'padding-right: 14px;', !focused &&
        "\n  &:hover {\n    fieldset {\n      border-color: ".concat(error ? tokens_1.colors.red400 : tokens_1.colors.gray600, ";\n    }\n  }\n  "));
};
exports.root = root;
var input = function (_a) {
    var startAdornment = _a.startAdornment, endAdornment = _a.endAdornment;
    return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0.8125rem 1rem 0.9375rem; //adjusting for 2px font offset\n  color: ", ";\n  line-height: 1.375rem;\n  box-sizing: border-box;\n  height: 3.125rem;\n\n  ", "\n  ", "\n"], ["\n  padding: 0.8125rem 1rem 0.9375rem; //adjusting for 2px font offset\n  color: ", ";\n  line-height: 1.375rem;\n  box-sizing: border-box;\n  height: 3.125rem;\n\n  ", "\n  ", "\n"])), tokens_1.colors.gray800, startAdornment && 'padding-left: 0px;', endAdornment && 'padding-right: 0px;');
};
exports.input = input;
var templateObject_1, templateObject_2;
//# sourceMappingURL=OutlinedInput.style.js.map